import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home as HomeIcon, ArrowLeft as ArrowLeftIcon } from "lucide-react";
import { usePageTitle } from "@/hooks/usePageTitle";
import styles from "./NotFound.module.css";

export default function NotFound() {
  const { t } = useTranslation();
  usePageTitle(t("notFound.title"));
  const navigate = useNavigate();

  return (
    <div className={styles.notFoundPage}>
      <div className={styles.notFoundContent}>
        <div className={styles.errorIcon}>🏭</div>
        <h1 className={styles.errorCode}>404</h1>
        <h2 className={styles.errorTitle}>{t("notFound.title")}</h2>
        <p className={styles.errorDescription}>
          {t("notFound.message")}
        </p>
        <div className={styles.errorActions}>
          <Link to="/" className={`${styles.btn} ${styles.btnPrimary}`}>
            <HomeIcon size={20} />
            {t("notFound.goHome")}
          </Link>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className={`${styles.btn} ${styles.btnSecondary}`}
          >
            <ArrowLeftIcon size={20} />
            {t("notFound.goBack")}
          </button>
        </div>
      </div>
    </div>
  );
}
